import data from "../../../../../packages/react/src/Breadcrumbs/Breadcrumbs.docs.json";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  DeprecationBanner,
  React
};